<!-- 收益趋势 -->
<template>
    <div class="a-mt-36">
        <div class="a-flex-rsbc">
            <div class="a-flex-rfsfe">
                <span class="a-c-master a-fw-700 a-fs-16">车库车辆趋势（截止昨日）</span>
            </div>
            <jd-other-date-range
                ref="dateRange"
                @change="dateChange"
                :pickerOptions="pickerOptions" 
                :timeType.sync="timeType"
                valueFormat="yyyy-MM-dd HH:mm:ss"
                :minDate.sync="startDate" 
                :maxDate.sync="endDate">
            </jd-other-date-range>
        </div>
        <!-- <div class="a-flex-rfec a-mt-16">
            <div class="a-flex-rfsc">
                <div class="tips2 "></div>
                <span class="a-c-normal a-fs-14 a-ml-11">当前车辆</span>
            </div>
            <div class="a-flex-rfsc a-ml-40">
                <div class="tips "></div>
                <span class="a-c-normal a-fs-14 a-ml-11">历史车辆</span>
            </div>
        </div> -->
        <div id="carCharts" class="mychart "></div>
    </div>
</template>

<script>
    export default {
        data () {
            return {
                myChartContxt: null,
                choiceDate: '',
                choiceMonth: '',
                pickerOptions: {
                    onPick: ({ maxDate, minDate }) => {
                        this.choiceDate = minDate.getTime()
                        this.choiceMonth = minDate
                        if (maxDate) {
                            this.choiceDate = ''
                            this.choiceMonth = ''
                        }
                    },
                    disabledDate: (time) => {
                        if (this.choiceDate) {
                            if(this.timeType == 0){
                                let one = 31 * 24 * 3600 * 1000
                                const minTime = this.choiceDate - one
                                const maxTime = this.choiceDate + one
                                return time.getTime() < minTime || time.getTime() > maxTime
                            }else if(this.timeType == 1){
                                let minMonth = this.choiceMonth.getMonth(),
                                lastYear = new Date(this.choiceMonth).setMonth(minMonth - 11),
                                nextYear = new Date(this.choiceMonth).setMonth(minMonth + 11);
                                return time.valueOf() < lastYear.valueOf() || time.valueOf() > nextYear.valueOf();
                            }
                        }else{
                            return ''
                        }
                    },
                },
                timeType: 0,
                startDate: '',
                endDate: '',
                params_req: ''
            }
        },
        created () {
            
        },
        props: ['id','params','infoType'],
        watch:{
            params:{
                immediate: true,
                handler (val) {
                    this.params_req = JSON.parse(JSON.stringify(val))
                    this.$nextTick(()=>{
                        if(this.infoType == 'province' || this.infoType == 'city'){
                            this.startDate = this.$getDay.getTodayBeforeDays(31) + ' 00:00:00'
                            this.endDate = this.$getDay.getTodayBeforeDays(1) + ' 23:59:59'
                        }else{
                            this.startDate = this.$getDay.getTodayBeforeDays(30) + ' 00:00:00'
                            this.endDate = this.$getDay.getTodayBeforeDays(0) + ' 23:59:59'
                        }
                        this.$refs['dateRange'].value1 = [this.startDate, this.endDate]
                        this.getChartData()
                    })
                }
            },
        },
        methods:{
            drawChart (xAxis=[], seriesData1=[], seriesData2=[]) { //横坐标, 交易金额，订单数量
                var chartDom = document.getElementById('carCharts');
                var option;
                option = {
                    color: ['#FFA900', '#6699FF', '#FF3030', '#FF9C00', '#FFD700','#3ba272'],
                    grid: {
                        left: '0',
                        right: '0',
                        bottom: '0',
                        top: '36px',
                        containLabel: true
                    },
                    legend: {
                        itemWidth: 8,
                        itemHeight: 8,
                        right: "2%",
                        itemGap: 40
                    },
                    tooltip: {
                        trigger: 'axis'
                    },
                    xAxis: {
                        type: 'category',
                        min: 0,
                        axisLine: {
                            lineStyle: {
                                color: '#DDDDDD'
                            }
                        },
                        axisTick: {
                            lineStyle: {
                                color: '#DDDDDD'
                            }
                        },
                        splitLine:{
                            show:false
                        },
                        axisLabel:{
                            color: '#999999',
                            showMaxLabel: true,
                            formatter: (value, index)=> {
                                if(this.timeType==0){
                                    let arr = value.split('-')
                                    return arr[1]+'-'+arr[2];
                                }
                                return value
                            }
                        },
                        data: xAxis
                    },
                    yAxis: {
                        type: 'value',
                        min: 0,
                        max: 'dataMax',
                        axisLine: {
                            show: false
                        },
                        axisTick: {
                            show: false,
                        },
                        splitLine:{
                            lineStyle:{
                                color: '#EEEEEE',
                                type: 'dashed'
                            }
                        },
                    },
                    series: [
                        {   
                            name: '当前车辆',
                            data: seriesData1,
                            type: 'line',
                            lineStyle:{
                                normal:{
                                    color: '#FFA900',
                                    width: 2
                                }
                            },
                            smooth: true
                        },
                        {
                            name: '历史车辆',
                            data: seriesData2,
                            type: 'line',
                            lineStyle:{
                                normal:{
                                    color: '#6699FF',
                                    width: 2
                                }
                            },
                            smooth: true
                        }
                    ]
                };
                if(!this.myChartContxt){
                    this.myChartContxt = this.$echarts.init(chartDom);
                }
                this.myChartContxt.clear()
                this.myChartContxt.setOption(option,true);
            },
            dateChange () {
                this.getChartData()
            },
            // 获取图表数据
            getChartData () {
                let apiUrl
                if(this.infoType == 'business'){
                    apiUrl = this.$Config.apiUrl.getBikeTrendsIndex
                }else if(this.infoType == 'income'){
                    apiUrl = this.$Config.apiUrl.getIncomeBikeTrends
                }else if(this.infoType == 'station'){
                    apiUrl = this.$Config.apiUrl.getStationBikeTrends
                }else if(this.infoType == 'province'){
                    apiUrl = this.$Config.apiUrl.getAnalysisCityBikeTrends
                }else if(this.infoType == 'city'){
                    apiUrl = this.$Config.apiUrl.getAnalysisCityBikeTrends
                }
                this.$Axios._post({
                    url: apiUrl,
                    method: "post",
                    showLoading: false,
                    params: {
                        ...this.params_req,
                        startDay: this.startDate,
                        endDay: this.endDate,
                        dateType: this.timeType
                    }
                }).then(res => {
                    if(res.result.code == 0){        
                        let dateArr
                        if(res.result.data.length){
                            dateArr = res.result.data
                        }else{
                            dateArr = this.$getDay.enumerateDaysBetweenDates(this.startDate,this.endDate).map(item=>{
                                return {
                                    day: item,
                                }
                            })
                        }                
                        let xAxis = []
                        let seriesData1 = []
                        let seriesData2 = []
                        dateArr.map(item=>{
                            xAxis.push(item.day)
                            seriesData1.push(item.current || 0)
                            seriesData2.push(item.history || 0)
                        })
                        this.drawChart(xAxis, seriesData1, seriesData2)
                    }else{
                        this.$message.error(res.result.message)
                    }
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
.tips2{
    width: 11px;
    height: 11px;
    background: #FFA900;
    border-radius: 3px;
}
.tips{
    width: 11px;
    height: 11px;
    background: #6699FF;
    border-radius: 3px;
}
.mychart{
    width: 100%;
    height: 300px;
}
.tooltips{
    background: #FFFFFF;
    box-shadow: 0px 5px 21px 0px rgba(139,147,167,0.25);
    opacity: 0.96;
}
.tooltipsTitle{
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #606366;
    line-height: 27px;
    padding: 0 25px;
}
.tooltipsContent{
    font-size: 21px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #303133;
    line-height: 32px;
}
</style>